import { useMemo } from 'react';
import { useClients } from '../contexts/ClientContext';
import { useClientScopedGate } from './useClientScopedGate';
import {
  readinessHasPlatform,
  readinessHasPosts,
} from '../utils/clientReadinessGate';

/**
 * Minimum activation: client → platform connected → at least one scheduled/published post (all-time).
 * Uses the same readiness API as ClientReadinessPanel / ClientScopedGate (3.2).
 */
export function useActivationStatus() {
  const { clients, loaded } = useClients();
  const gate = useClientScopedGate();

  const steps = useMemo(() => {
    const hasClient = clients.length > 0;
    const hasPlatform =
      hasClient && gate.readiness != null && readinessHasPlatform(gate.readiness);
    const hasPost =
      hasClient && gate.readiness != null && readinessHasPosts(gate.readiness);

    return {
      hasClient,
      hasPlatform,
      hasPost,
    };
  }, [clients.length, gate.readiness]);

  const isComplete =
    steps.hasClient && steps.hasPlatform && steps.hasPost;

  return {
    loading: !loaded || gate.loading,
    steps,
    isComplete,
    clientId: gate.clientId,
    readiness: gate.readiness,
  };
}
